// This component has two modes depending on what type of children it is passed.
// If it is given a React tree, the tree will be rendered if & only if the
// current project is a Canada project.
// If it is given a function, it will call that function with a single boolean
// argument indicating whether the current project is a Canada project.
import React from 'react';
import SpecifiedCountryOnly from './SpecifiedCountryOnly';

const CanadaOnly = ({ children }) => (
  <SpecifiedCountryOnly countryCode="CA">{children}</SpecifiedCountryOnly>
);

export default CanadaOnly;
